import { getPath } from '@/router/common'
const baseUrl = {
  title: '工单管理',
  path: 'AcceptanceOfBill'
}

export default [
  {
    path: getPath('OrderAppointment', baseUrl),
    name: 'OrderAppointment',
    component: () =>
      import(
        /* webpackChunkName: "GridDPM" */ '@/views/acceptanceOfBill/orderAppointment/index.vue'
      ),
    meta: {
      title: '订单预约'
    }
  },
  {
    path: getPath('WorkOrderRecordIndex', baseUrl),
    name: 'WorkOrderRecordIndex',
    component: () => import(/* webpackChunkName: "WorkOrderRecordIndex" */ '@/views/acceptanceOfBill/workOrderRecordIndex/index.vue'),
    meta: {
      title: '工单管理'
    }
  },
  {
    path: getPath('WorkOrderRecordDetail', baseUrl),
    name: 'WorkOrderRecordDetail',
    component: () => import(/* webpackChunkName: "WorkOrderRecordDetail" */ '@/views/acceptanceOfBill/workOrderRecordDetail/index.vue'),
  },
  {
    path: getPath('GridDPM', baseUrl),
    name: 'AcceptanceOfBill_GridDPM',
    component: () => import(/* webpackChunkName: "AcceptanceOfBill_GridDPM" */ '@/views/acceptanceOfBill/gridDPM/index.vue'),
    meta: {
      title: '新增或者编辑工单'
    }
  },
  {
    path: getPath('ViewPicture', baseUrl),
    name: 'AcceptanceOfBill_ViewPicture',
    component: () => import(/* webpackChunkName: "AcceptanceOfBill_ViewPicture" */ '@/views/acceptanceOfBill/viewPicture/index.vue'),
    meta: {
      title: '查看图片'
    }
  },
  // {
  //   path: getPath('GridDPM', baseUrl),
  //   name: 'GridDPM',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "GridDPM" */ '@/views/acceptanceOfBill/gridDPM/index.vue'
  //     ),
  //   meta: {
  //     title: '订单大全数据(多品名)'
  //   }
  // }
  {
    path: getPath('WeChat', baseUrl),
    name: 'WeChat',
    component: () => import( /* webpackChunkName: "WeChart" */ '@/views/acceptanceOfBill/weChat/index.vue' ),
    meta: {
      title: '微信下单'
    }
  },
  {
    path: getPath('SMSRecharge', baseUrl),
    name: 'SMSRecharge',
    component: () => import( /* webpackChunkName: "WeChart" */ '@/views/acceptanceOfBill/SMSRecharge/index.vue' ),
    meta: {
      title: '短信充值'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'AcceptanceOfBill_index',
    component: () => import(/* webpackChunkName: "AcceptanceOfBill_index" */ '@/views/acceptanceOfBill/index/index.vue'),
    meta: {
      title: '受理开单'
    }
  },
  {
    path: getPath('UpdateAccsendoutData', baseUrl),
    name: 'AcceptanceOfBill_UpdateAccsendoutData',
    component: () => import(/* webpackChunkName: "AcceptanceOfBill_UpdateAccsendoutData" */ '@/views/acceptanceOfBill/updateAccsendoutData/index.vue'),
    meta: {
      title: '修改实际接货费'
    }
  },
  {
    path: getPath('PayScanCode', baseUrl),
    name: 'payScanCode',
    component: () => import( /* webpackChunkName: "PayScanCode" */ '@/views/acceptanceOfBill/payScanCode/index.vue' ),
    meta: {
      title: '扫码付款'
    }
  },
  {
    path: getPath('batchModifyOrder', baseUrl),
    name: 'batchModifyOrder',
    component: () => import(/* webpackChunkName: "batchModifyOrder_Index" */ '@/views/acceptanceOfBill/batchModifyOrder/index.vue'),
    meta: {
      title: '批量改单'
    }
  },
  {
    path: getPath('batchTransactionOrder', baseUrl),
    name: 'batchTransactionOrder',
    component: () => import(/* webpackChunkName: "batchModifyOrder_Index" */ '@/views/acceptanceOfBill/batchTransactionOrder/index.vue'),
    meta: {
      title: '批量异动'
    }
  },
  {
    path: getPath('orderFeeOutInAdjust', baseUrl),
    name: 'orderFeeOutInAdjust',
    component: () => import(/* webpackChunkName: "orderFeeOutInAdjust_Index" */ '@/views/acceptanceOfBill/orderFeeOutInAdjust/index.vue'),
    meta: {
      title: '运单收支调整'
    }
  },
  {
    path: getPath('addFeeOutInAdjust', baseUrl),
    name: 'addFeeOutInAdjust',
    component: () => import(/* webpackChunkName: "addFeeOutInAdjust_Index" */ '@/views/acceptanceOfBill/addFeeOutInAdjust/index.vue'),
    meta: {
      title: '新增运单收支调整'
    }
  },
  {
    path: getPath('addFeeOutInBatchAdjust', baseUrl),
    name: 'addFeeOutInBatchAdjust',
    component: () => import(/* webpackChunkName: "addFeeOutInBatchAdjust_Index" */ '@/views/acceptanceOfBill/addFeeOutInBatchAdjust/index.vue'),
    meta: {
      title: '批量新增运单收支调整'
    }
  },
]
